export default "__VITE_ASSET__w2_438b4__"